import React from 'react';

export default function Tabs({ tabs, active, onChange, className = '' }) {
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onChange(tab.value)}
          className={`border rounded-full px-3 py-2 text-xs font-semibold transition-colors ${
            active === tab.value
              ? 'bg-seha-500 text-white border-seha-500'
              : 'bg-white text-neutral-600 border-neutral-200 hover:bg-neutral-50 dark:bg-ink-900 dark:text-neutral-300 dark:border-neutral-700 dark:hover:bg-ink-800'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
